<template>
    <div class="dialogBox">
        <el-dialog title="运单明细"
                   :modal="false"
                   width="80%"
                   :visible.sync="dialogCTableVisible">
            <el-table :data="paginationTableData"
                      border
                      style="width: 100%">
                <el-table-column label="序号"
                                 type="index" />
                <el-table-column v-for="(item, index) in tableConfig.table.columns"
                                 :key="index"
                                 :width="item.width"
                                 show-overflow-tooltip
                                 :label="item.label"
                                 :prop="item.prop">
                    <template slot-scope="scope">
                        {{ scope.row[item.prop] }}
                    </template>
                </el-table-column>
            </el-table>
            <div class="block">
                <el-pagination :current-page.sync="currentPage"
                               :page-size="pageSize"
                               :total="tableData.length"
                               class="table-pagination"
                               layout="total, prev, pager, next"
                               @size-change="handleSizeChange"
                               @current-change="handleCurrentChange">
                </el-pagination>
            </div>

        </el-dialog>
    </div>
</template>
<script>
import { waybillConfig } from './config';

export default {
    name: 'dispatch-history-detail-dialog-tasks',
    props: {
        tableData: {
            type: Array,
            default () {
                return [];
            }
        }
    },
    data () {
        return {
            dialogCTableVisible: false,
            tableConfig: waybillConfig,
            currentPage: 1,
            pageSize: 10
        };
    },
    computed: {
        paginationTableData () {
            const s = this.pageSize;
            const i = this.currentPage - 1;
            return this.tableData.slice(s * i, s * (i + 1));
        }
    },
    methods: {
        handleSizeChange (val) {
            this.pageSize = val;
        },
        handleCurrentChange (val) {
            this.currentPage = val;
        },
        show () {
            this.dialogCTableVisible = true;
        },
        handleClose () {
            this.dialogCTableVisible = false;
        }
    }
};
</script>
<style lang="less" scoped>
.dialogBox {
    .el-dialog__body {
        padding: 5px;
    }

    .block {
        height: 30px;
        padding-top: 10px;

        .table-pagination {
            text-align: right;

            .btn-prev,
            .btn-next,
            .el-pager li {
                background-color: #ffffff !important;
                border: 1px solid #cccccc;
                border-radius: 4px !important;
                padding: 0;
                min-width: 30px;
                margin-right: 4px;
            }

            .el-pager li.active + li {
                border-left: 1px solid #cccccc;
            }

            .el-pager li:not(.disabled).active {
                background-color: #00bcbf !important;
                border: 1px solid #00bcbf;
                color: #ffffff;
            }
        }
    }
}
</style>
